module["exports"] = [
  "#{city_prefix}#{city_suffix}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/zh_TW/address/city.js
 ** module id = 1127
 ** module chunks = 0
 **/